import { ApiResponse } from "apisauce";

// Api
import { api } from "../api";
import { getGeneralApiProblem } from "../general-api-problems/general-api-problems";
import {
  ExceptionPayload,
  GeneralApiProblem,
} from "../general-api-problems/general-api-problems.types";

import {
  TruckManufacturerResponse,
  TruckManufacturerResponseDataType,
  TrucksManufacturersResponse,
  TrucksManufacturersResponseDataType,
  MessageResponse,
  MessageResponseType,
} from "../../models/api/responses";

import { ManufacturerRequest } from "../../models/api/requests";

import { ManufacturerFormModel } from "../../models/app/form";

/**
 * Get Trucks manufacturers request
 * @returns TrucksManufacturersResponse or GeneralApiProblem
 */

export const getTrucksManufacturers = async (): Promise<
  TrucksManufacturersResponse | GeneralApiProblem
> => {
  const response: ApiResponse<
    TrucksManufacturersResponseDataType,
    ExceptionPayload
  > = await api.apisauce.get(`/truck-manufacturer`);

  if (!response.ok) {
    return getGeneralApiProblem(response);
  }
  const responseData = response.data as TrucksManufacturersResponseDataType;
  return new TrucksManufacturersResponse(responseData);
};

/**
 * Create truck manufacturer request
 * @param manufacturerForm - ManufacturerFormModel
 * @returns TruckManufacturerResponse or GeneralApiProblem
 */
export const createTruckManufacturerRequest = async (
  manufacturerForm: ManufacturerFormModel
): Promise<TruckManufacturerResponse | GeneralApiProblem> => {
  const requestPayload = new ManufacturerRequest(manufacturerForm);

  const response: ApiResponse<
    TruckManufacturerResponseDataType,
    ExceptionPayload
  > = await api.apisauce.post("/truck-manufacturer", requestPayload);

  if (!response.ok) {
    const problem = getGeneralApiProblem(response);
    return problem;
  }

  const responseData = response.data as TruckManufacturerResponseDataType;

  return new TruckManufacturerResponse(responseData);
};

/**
 * Update truck manufacturer request
 * @param manufacturerForm - ManufacturerFormModel
 * @param id - string
 * @returns TruckManufacturerResponse or GeneralApiProblem
 */
export const updateTruckManufacturerRequest = async (
  manufacturerForm: ManufacturerFormModel,
  id?: number
): Promise<TruckManufacturerResponse | GeneralApiProblem> => {
  const requestPayload = new ManufacturerRequest(manufacturerForm);

  const response: ApiResponse<
    TruckManufacturerResponseDataType,
    ExceptionPayload
  > = await api.apisauce.patch(`/truck-manufacturer/${id}`, requestPayload);

  if (!response.ok) {
    const problem = getGeneralApiProblem(response);
    return problem;
  }

  const responseData = response.data as TruckManufacturerResponseDataType;

  return new TruckManufacturerResponse(responseData);
};

/**
 * Delete truck manufacturer request
 * @param id - string
 * @returns MessageResponse or GeneralApiProblem
 */
export const deleteManufacturerRequest = async (
  id: number
): Promise<MessageResponse | GeneralApiProblem> => {
  const response: ApiResponse<MessageResponseType, ExceptionPayload> =
    await api.apisauce.delete(`/truck-manufacturer/${id}`);

  if (!response.ok) {
    const problem = getGeneralApiProblem(response);
    return problem;
  }

  const responseData = response.data as MessageResponseType;

  return new MessageResponse(responseData);
};
